<jep-container-layout 
    [layout]="layout$ | async">
</jep-container-layout>